var Education = "教育機関";
var Enterprise = "エンタープライズ";
var CompanyType = {
	"Company type": "会社の種類",
	Education: Education,
	Enterprise: Enterprise,
	"Government - Federal": "政府 - 官公庁",
	"Government - State & local": "政府 - 地方自治体",
	"Non-profit": "非営利団体",
	"Self employed": "自営業",
	"Small-medium business": "中小企業",
	"Start-up": "スタートアップ",
	"Not applicable": "該当しない"
};

export { Education, Enterprise, CompanyType as default };
